import React, { useState } from "react";

const ProcurementSupplyChain = ({ onSaveProcurement }) => {
  const [procurementData, setProcurementData] = useState({
    preferredVendors: "",
    vendorItemCode: "",
    vendorLeadTime: "",
    procurementCategory: "Pharmaceuticals", // Default category
    purchasesUoM: "Box", // Default UoM
    approvalRequired: false,
    qualityCertification: "",
    contractExpiryDate: "",
  });

  // UoM Options
  const purchaseUoMOptions = [
    "Box",
    "Pack",
    "Bottle",
    "Carton",
    "Kilogram",
    "Liter",
    "Unit",
    "Case",
  ];

  // Handle Input Change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setProcurementData({
      ...procurementData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  // Handle Save
  const handleSave = () => {
    onSaveProcurement(procurementData);
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <h2 className="text-2xl font-bold mb-4">Procurement & Supply Chain</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        {/* Procurement Category */}
        <div>
          <label className="block text-gray-700 font-medium">
            Procurement Category
          </label>
          <select
            name="procurementCategory"
            value={procurementData.procurementCategory}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-lg p-2 mt-2"
          >
            <option value="Pharmaceuticals">Pharmaceuticals</option>
            <option value="Medical Equipment">Medical Equipment</option>
            <option value="Consumables">Consumables</option>
            <option value="Surgical Instruments">Surgical Instruments</option>
            <option value="Laboratory Supplies">Laboratory Supplies</option>
          </select>
        </div>

        {/* Preferred Vendors */}
        <div>
          <label className="block text-gray-700 font-medium">
            Preferred Vendors
          </label>
          <input
            type="text"
            name="preferredVendors"
            value={procurementData.preferredVendors}
            onChange={handleChange}
            placeholder="e.g., Vendor A, Vendor B"
            className="w-full border border-gray-300 rounded-lg p-2 mt-2"
          />
        </div>

        {/* Vendor Item Code */}
        <div>
          <label className="block text-gray-700 font-medium">
            Vendor Item Code
          </label>
          <input
            type="text"
            name="vendorItemCode"
            value={procurementData.vendorItemCode}
            onChange={handleChange}
            placeholder="Enter vendor-specific item code"
            className="w-full border border-gray-300 rounded-lg p-2 mt-2"
          />
        </div>

        {/* Vendor Lead Time */}
        <div>
          <label className="block text-gray-700 font-medium">
            Vendor Lead Time (days)
          </label>
          <input
            type="number"
            name="vendorLeadTime"
            value={procurementData.vendorLeadTime}
            onChange={handleChange}
            placeholder="Enter lead time in days"
            className="w-full border border-gray-300 rounded-lg p-2 mt-2"
          />
        </div>

        {/* Purchases UoM */}
        <div>
          <label className="block text-gray-700 font-medium">
            Purchases UoM
          </label>
          <select
            name="purchasesUoM"
            value={procurementData.purchasesUoM}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-lg p-2 mt-2"
          >
            {purchaseUoMOptions.map((uom) => (
              <option key={uom} value={uom}>
                {uom}
              </option>
            ))}
          </select>
        </div>

        {/* Approval Required */}
        <div>
          <label className="block text-gray-700 font-medium">
            Approval Required
          </label>
          <input
            type="checkbox"
            name="approvalRequired"
            checked={procurementData.approvalRequired}
            onChange={handleChange}
            className="mr-2 mt-5"
          />
          <span>Check if approval is required</span>
        </div>

        {/* Contract Expiry Date */}
        <div>
          <label className="block text-gray-700 font-medium">
            Contract Expiry Date
          </label>
          <input
            type="date"
            name="contractExpiryDate"
            value={procurementData.contractExpiryDate}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-lg p-2 mt-2"
          />
        </div>
      </div>

      {/* Save Button */}
      <button
        type="button"
        onClick={handleSave}
        className="mt-4 bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700"
      >
        Save Procurement Details
      </button>
    </div>
  );
};

export default ProcurementSupplyChain;
